<template>
  <footer class="footer">
    <TheFooterNavbar />
    <ContainerInner class="footer__inner">
      <div class="footer__disclaimer" v-html="gdpr.wysiwyg"></div>
    </ContainerInner>
  </footer>
</template>

<script>
import ContainerInner from '@containers/ContainerInner'
import TheFooterNavbar from './TheFooterNavbar'
import { mapGetters } from 'vuex'
export default {
  name: 'TheFooter',
  components: {
    ContainerInner,
    TheFooterNavbar
  },
  data () {
    return {}
  },
  created () {
  },
  computed: {
    ...mapGetters({
      gdpr: 'footer/getGdpr'
    }),
    wysiwyg () {
      return this.gdpr.wysiwig
    }
  }
}
</script>

<style lang="scss">
  .footer{
    @media print {
      display: none !important;
    }
    background-color: colors("topbar");
    color: shade(white, 35%);
    font-size: 1.3rem;

    &__inner{
      @include media("small-medium"){
        padding: 0;
      }
    }

    &__disclaimer{
      @include media("small-medium"){
        padding: 1.5rem 2rem;
      }
      @include media("large"){
        padding: 1.5rem 0;
      }
      p{
        margin-bottom: 1.5rem;
      }
      a{
        color: shade(white, 30%);
        text-decoration: underline;
        white-space: nowrap;
        @include hover{
          color: white;
          text-decoration: underline;
        }
      }
    }
  }
</style>
